var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "card-container", attrs: { shadow: "hover" } },
        [
          _c("app-divider", {
            staticClass: "margin-bottom",
            attrs: { label: "Dados do VTN RR: ", addMarginTop: false }
          }),
          _c(
            "div",
            { staticClass: "center" },
            [
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-row",
                    { staticClass: "flexRow", attrs: { gutter: 16 } },
                    [
                      _c("app-label", {
                        staticClass: "appLabel",
                        attrs: {
                          label: "Área total do imóvel georreferenciado (ha):",
                          required: _vm.required
                        }
                      }),
                      _c("validation-provider", {
                        attrs: { rules: "required|notZero", name: "area" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("app-double-input", {
                                  staticClass: "appInput",
                                  attrs: {
                                    name: "Área",
                                    precision: 4,
                                    onkeypress: _vm.onlyInputNumbers,
                                    hasValidationError: !!errors.length
                                  },
                                  on: { change: _vm.atualizaValorModuloFiscal },
                                  model: {
                                    value:
                                      _vm.vtnRequest
                                        .areaTotalImovelGeorreferenciado,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.vtnRequest,
                                        "areaTotalImovelGeorreferenciado",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "vtnRequest.areaTotalImovelGeorreferenciado"
                                  }
                                }),
                                _c("span", { staticClass: "help erro" }, [
                                  _vm._v(_vm._s(errors[0]))
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticClass: "flexRow", attrs: { gutter: 16 } },
                    [
                      _c("app-label", {
                        staticClass: "appLabel",
                        attrs: { label: "Gleba:" }
                      }),
                      _c("validation-provider", {
                        attrs: { rules: "required", name: "Gleba" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("el-input", {
                                  staticClass: "appInput",
                                  class: { "input erro": !!errors.length },
                                  attrs: { name: "Gleba", maxlength: 50 },
                                  model: {
                                    value: _vm.vtnRequest.gleba,
                                    callback: function($$v) {
                                      _vm.$set(_vm.vtnRequest, "gleba", $$v)
                                    },
                                    expression: "vtnRequest.gleba"
                                  }
                                }),
                                _c("span", { staticClass: "help erro" }, [
                                  _vm._v(_vm._s(errors[0]))
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticClass: "flexRow", attrs: { gutter: 16 } },
                    [
                      _c("app-label", {
                        staticClass: "appLabel",
                        attrs: {
                          label: "Tempo de ocupação (em anos):",
                          required: _vm.required
                        }
                      }),
                      _c("validation-provider", {
                        attrs: { rules: "required", name: "Tempo de ocupação" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("el-input", {
                                  staticClass: "appInput",
                                  class: { "input erro": !!errors.length },
                                  attrs: {
                                    name: "Tempo de ocupação",
                                    maxlength: 3,
                                    onkeypress: _vm.onlyInputNumbers
                                  },
                                  model: {
                                    value: _vm.vtnRequest.tempoOcupacao,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.vtnRequest,
                                        "tempoOcupacao",
                                        $$v
                                      )
                                    },
                                    expression: "vtnRequest.tempoOcupacao"
                                  }
                                }),
                                _c("span", { staticClass: "help erro" }, [
                                  _vm._v(_vm._s(errors[0]))
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticClass: "flexRow", attrs: { gutter: 16 } },
                    [
                      _c("app-label", {
                        staticClass: "appLabel",
                        attrs: {
                          label:
                            "Distância da capital Boa Vista em linha reta (Km):",
                          required: _vm.required
                        }
                      }),
                      _c("validation-provider", {
                        attrs: {
                          rules: "required|notZero",
                          name: "Distância da capital"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("app-double-input", {
                                  staticClass: "appInput",
                                  class: { "input erro": !!errors.length },
                                  attrs: {
                                    name: "Distância da capital",
                                    precision: 1,
                                    onkeypress: _vm.onlyInputNumbers,
                                    hasLimitValue: 6,
                                    hasValidationError: !!errors.length
                                  },
                                  model: {
                                    value: _vm.vtnRequest.distanciaBoaVista,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.vtnRequest,
                                        "distanciaBoaVista",
                                        $$v
                                      )
                                    },
                                    expression: "vtnRequest.distanciaBoaVista"
                                  }
                                }),
                                _c("span", { staticClass: "help erro" }, [
                                  _vm._v(_vm._s(errors[0]))
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticClass: "flexRow", attrs: { gutter: 16 } },
                    [
                      _c("app-label", {
                        staticClass: "appLabel",
                        attrs: {
                          label:
                            "Há conduta ou atividade lesiva ao meio ambiente?",
                          required: _vm.required
                        }
                      }),
                      _c(
                        "el-radio-group",
                        {
                          staticClass: "radio-group",
                          attrs: { name: "Conduta ou atividade lesiva" },
                          model: {
                            value: _vm.vtnRequest.condutaLesivaMeioAmbiente,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.vtnRequest,
                                "condutaLesivaMeioAmbiente",
                                $$v
                              )
                            },
                            expression: "vtnRequest.condutaLesivaMeioAmbiente"
                          }
                        },
                        [
                          _c(
                            "el-radio",
                            { staticClass: "radio", attrs: { label: false } },
                            [_vm._v("Inexistente")]
                          ),
                          _c(
                            "el-radio",
                            { staticClass: "radio", attrs: { label: true } },
                            [_vm._v("Existente")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-row",
                    { staticClass: "flexRow", attrs: { gutter: 16 } },
                    [
                      _c("app-label", {
                        staticClass: "appLabel",
                        attrs: {
                          label: "Módulo Fiscal do Múnicípio - MF (ha):",
                          required: _vm.required
                        }
                      }),
                      _c("app-double-input", {
                        staticClass: "appInput",
                        attrs: {
                          name: "Módulo Fiscal do Múnicípio",
                          precision: 2,
                          onkeypress: _vm.onlyInputNumbers,
                          disable: _vm.disable
                        },
                        model: {
                          value: _vm.vtnRequest.moduloFiscal,
                          callback: function($$v) {
                            _vm.$set(_vm.vtnRequest, "moduloFiscal", $$v)
                          },
                          expression: "vtnRequest.moduloFiscal"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.isRoraima
                    ? _c(
                        "el-row",
                        { staticClass: "flexRow", attrs: { gutter: 16 } },
                        [
                          _c("app-label", {
                            staticClass: "appLabel",
                            attrs: {
                              label: "Munícipio:",
                              required: _vm.required
                            }
                          }),
                          _c(
                            "div",
                            {
                              staticClass:
                                "el-input-group el-input-group--prepend appInput"
                            },
                            [
                              _c("validation-provider", {
                                attrs: { rules: "required", name: "distancia" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _vm.temMunicipio
                                            ? _c("el-input", {
                                                attrs: {
                                                  disabled: _vm.disable
                                                },
                                                model: {
                                                  value:
                                                    _vm.vtnRequest.municipio
                                                      .nome,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.vtnRequest.municipio,
                                                      "nome",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "vtnRequest.municipio.nome"
                                                }
                                              })
                                            : _vm._e(),
                                          !_vm.temMunicipio
                                            ? _c(
                                                "el-select",
                                                {
                                                  attrs: {
                                                    placeholder: "Selecione",
                                                    "value-key": "Município"
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.calculaModuloFiscalPorMunicipio
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.vtnRequest.municipio
                                                        .id,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.vtnRequest
                                                          .municipio,
                                                        "id",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "vtnRequest.municipio.id"
                                                  }
                                                },
                                                _vm._l(_vm.municipios, function(
                                                  municipio
                                                ) {
                                                  return _c("el-option", {
                                                    key: municipio.id,
                                                    attrs: {
                                                      label: municipio.nome,
                                                      value: municipio.id
                                                    }
                                                  })
                                                }),
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "span",
                                            { staticClass: "help erro" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2642935330
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-row",
                    { staticClass: "flexRow", attrs: { gutter: 16 } },
                    [
                      _c("app-label", {
                        staticClass: "appLabel",
                        attrs: {
                          label: "Número de Módulos fiscais:",
                          required: _vm.required
                        }
                      }),
                      _c("app-double-input", {
                        staticClass: "appInput",
                        attrs: {
                          name: "Número de Módulos fiscais",
                          precision: 2,
                          onkeypress: _vm.onlyInputNumbers,
                          disable: _vm.disable
                        },
                        model: {
                          value: _vm.vtnRequest.qtdModuloFiscal,
                          callback: function($$v) {
                            _vm.$set(_vm.vtnRequest, "qtdModuloFiscal", $$v)
                          },
                          expression: "vtnRequest.qtdModuloFiscal"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-192e46a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-192e46a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/vtn/components/InformarDadosRR.vue
// module id = null
// module chunks = 